<template>
  <div style="height: 100%">
    <video autoplay controls height="100%" muted ref="videoElement" width="100%"></video>
  </div>
</template>

<script>
import flvJs from "flv.js";
import {cameraHeartbeat} from "@/network/video";

export default {
  name: "VideoPlayback",
  props: ['deviceId','selectedHistoricalVideoAddressList','videoCameraId'],
  data() {
    return {
      timer: '',
      flvPlayer: null,
      cameraId: '',
    };
  },
  watch: {
    videoCameraId(newCameraId) {
      console.log("视频参数： ",newCameraId);
      this.cameraId = newCameraId;
      this.initFlv();
    }
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'cameraHeartbeat' + this.cameraId)
    this.flvPlayer.on(flvJs.Events.ERROR, (errType, errDetail) => {
      console.log(errDetail, errType);
    });
  },
  mounted() {
    this.cameraId = this.videoCameraId;
    this.initFlv();
  },
  methods:{
    initFlv() {
      console.log("历史视频播放！",window.g.ftpUrl + "dcim/video/"+this.cameraId);

      if (flvJs.isSupported() && this.cameraId != '') {
        var videoElement = this.$refs.videoElement;
        this.flvPlayer = flvJs.createPlayer({
          type: 'flv',
          isLive: true,
          hasAudio: false,
          url: window.g.ftpUrl + "dcim/video/" + this.cameraId
        });
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
        this.flvPlayer.play();
        //异常监听
        this.flvPlayer.on(flvJs.Events.ERROR, (errType, errDetail) => {
          this.errorCallback(errType, errDetail)
        });
        //视频播放完毕
        this.flvPlayer.on(flvJs.Events.LOADING_COMPLETE, () => {
        });
        let cameraHeartBeat = {};
        cameraHeartBeat['cameraHeartbeat' + this.cameraId + ':5000'] = this.cameraHeartbeat
        this.$store.dispatch('addIntervalObj', cameraHeartBeat)
      }
    },
    cameraHeartbeat() {
      cameraHeartbeat(this.cameraId).then(res => {
        console.log(res.data);
      })
    },
    errorCallback(errType, errDetail) {
      if (this && !this.isDestroyed) {
        return
      }
      console.log("---ERROR--", errType, errDetail)
      // errType是 NetworkError时，对应errDetail有：Exception、HttpStatusCodeInvalid、ConnectingTimeout、EarlyEof、UnrecoverableEarlyEof
      // errType是 MediaError时，对应errDetail是MediaMSEError
      if (this.timer) {
        clearTimeout(this.timer);
      }
      //网络异常情况
      if (errType === flvJs.ErrorTypes.NETWORK_ERROR && errDetail === flvJs.ErrorDetails.NETWORK_UNRECOVERABLE_EARLY_EOF) {
        this.initFlv();
      } else {
        this.timer = setTimeout(this.initFlv, 5000);
      }
    },
  }
}
</script>

<style scoped>

</style>
